$(window).one('maps_loaded', function () {
  initCreating()
  global.modules.set({
    init() {
      initCreating()
    }
  })
});

function initCreating() {
  const elem = $('#map.creating')[0];
  if (!elem) {
    return;
  }
  const logtitudeInput = document.getElementById('logtitude-input');
  const latitudeInput = document.getElementById('latitude-input');
  const input = document.getElementById('pac-input');
  const position = { lat: +latitudeInput?.value || 40.6869908, lng: +logtitudeInput?.value || -74.1616497 }
  const map = new google.maps.Map(
    elem,
    {
      center: position,
      zoom: 9,
      clickableIcons: false
    }
  );
  if (!logtitudeInput.value && !latitudeInput.value && navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const pos = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
        map.setCenter(pos);
      }
    );
  }
  const autocomplete = new google.maps.places.Autocomplete(input, {
    fields: ['place_id', 'geometry', 'formatted_address', 'name', 'types'],
  });
  autocomplete.setTypes(['address'])
  geocoder = new google.maps.Geocoder();

  autocomplete.bindTo("bounds", map);
  const marker = new google.maps.Marker({ map: map });
  const places = new google.maps.places.PlacesService(map);

  if (latitudeInput?.value && logtitudeInput?.value) {
    marker.setPosition(position);
  }

  map.addListener('click', function (e) {
    if (e.placeId) {
      logtitudeInput.value = e.latLng.lng();
      latitudeInput.value = e.latLng.lat();
      places.getDetails({
        placeId: e.placeId
      }, (place, status) => {
        marker.setVisible(false);
        input.value = place.formatted_address;
        marker.setPlace({
          placeId: place.place_id,
          location: place.geometry.location,
        });
      })
    } else {
      geocoder.geocode({ location: e.latLng }, function (results, status) {
        marker.setVisible(true);
        marker.setPosition(e.latLng);
        input.value = results[0].formatted_address
        logtitudeInput.value = results[0].geometry.location.lng();
        latitudeInput.value = results[0].geometry.location.lat();
      });
    }
  });

  autocomplete.addListener('place_changed', () => {
    const place = autocomplete.getPlace();

    if (!place.geometry || !place.geometry.location) {
      return;
    }
    logtitudeInput.value = place.geometry.location.lng();
    latitudeInput.value = place.geometry.location.lat();

    if (place.geometry.viewport) {
      map.fitBounds(place.geometry.viewport);
    } else {
      map.setCenter(place.geometry.location);
      map.setZoom(17);
    }
    marker.setPlace({
      placeId: place.place_id,
      location: place.geometry.location,
    });
  });
}
